import { useNavigate } from "@tanstack/react-router";
import type { AuthUser } from "../../auth/auth";
import { useRoom } from "../../lib/rooms";
import { RoomControllerProvider } from "../../room/RoomContext";
import type { RoomController } from "../../room/types";
import { CallBar } from "./CallBar";

// Binds the call bar to the app's active call; mounted only while it shows.
export function ActiveCallBar({
  call,
  user,
  onSignOut,
}: {
  call: { roomId: string; controller: RoomController };
  user: AuthUser | null;
  onSignOut: () => void;
}) {
  const navigate = useNavigate();
  // Shares the query RoomPage already filled, so the room is usually cached.
  const { data: room } = useRoom(call.roomId);
  return (
    <RoomControllerProvider value={call.controller}>
      <CallBar
        roomName={room?.name ?? ""}
        hasPasscode={room?.hasPassword ?? false}
        maxParticipants={room?.maxParticipants ?? undefined}
        user={user}
        onSignOut={onSignOut}
        onReturn={() => void navigate({ to: "/room/$roomId", params: { roomId: call.roomId } })}
      />
    </RoomControllerProvider>
  );
}
